import { ProductPageLayout } from '../components/ProductPageLayout';

export function BaseKarakterWorkflowPage() {
    return <ProductPageLayout productId="base-karakter-workflow" />;
}
